import * as API from '@common/api/workspace'
import * as T from './types'

const actions = {
    async [T.GET_WORKSPACE_LIST]({ commit }, data) {
        const { loading = true, getCurrent = true, ...payload } = data
        commit(T.UPDATE_WORKSPACE_LOADING,  loading)
        try {
            const res = []
            if (getCurrent) {
                const selected = await API.getBranchSelected(payload.appId, payload.workspaceId)
                const selectWorkspaceId = selected.workspaceId
                // res = await API.getWorkspaceList({ ...payload, selectWorkspaceId })
               
                if (selectWorkspaceId) {
                    // const target = res.items.find(item => item.workspaceId === selectWorkspaceId)
                    // if (target) {
                    commit(T.SET_CURRENT_WORKSPACE, selected)
                    // }
                }
            } else {
                // res = await API.getWorkspaceList(payload)
            }
            commit(T.SET_WORKSPACE_LIST, res.items.filter(item => !!item))
        } catch (error) {
            commit(T.SET_WORKSPACE_LIST, [])
        } finally {
            commit(T.UPDATE_WORKSPACE_LOADING, false)
        }
    },
    [T.EDIT_WORKSPACE](store, payload) {
        return API.editWorkspace(payload).then(res => res)
    },
    [T.DELETE_WORKSPACE](store, payload) {
        return API.deleteWorkspace(payload).then(res => res)
    },
    [T.GET_APP_VERSION_LIST](store, payload) {
        return API.getAppVersionList(payload).then(res => res)
    },
    [T.GET_WORKSPACE_COMPONENTS_LIST]() {
        return API.getWorkspaceComponentsList().then(res => res)
    },
    [T.ADD_COMPONENT_QUOTES](store, payload) {
        return API.addComponentQuotes(payload).then(res => res)
    },
    [T.DELETE_COMPONENT_QUOTES](store, payload) {
        return API.deleteComponentQuotes(payload).then(res => res)
    },
    [T.UPDATE_COMPONENT_QUOTES_VERSION](store, payload) {
        return API.updateComponentQuotesVerison(payload).then(res => res)
    },
    [T.GET_WORKSPACE_QUOTES_COMPONENTS_LIST]() {
        return API.getWorkspaceQuotesComponentsList().then(res => res)
    },
    [T.GET_APP_VERSION]({ commit }, payload) {
        return API.getAppVersion(payload).then(res => {
            commit(T.SET_APP_INFO, res)
            return res
        })
    },
    [T.GET_ENGINE_VERSION](sotre, payload) {
        return API.getEngineVersion(payload).then(res => res)
    },
    [T.GET_ENV_LIST](sotre, payload) {
        return API.getEnvList(payload).then(res => res)
    },
    [T.DELETE_APP_VERSION](sotre, payload) {
        return API.deleteAppVersion(payload).then(res => res)
    },
    [T.GET_APP_VERSION_ENV_LIST](sotre, payload) {
        return API.getVersionEnvList(payload).then(res => res)
    },
    [T.GET_ROLES_LIST]({ commit }, params) {
        return API.getRolesList(params)
            .then(res => {
                commit(T.SET_ROLES_LIST, res)
                return res
            })
    },
    [T.ADD_ROLE](store, params) {
        return API.addRole(params)
            .then(res => res)
    },
    [T.UPDATE_ROLE](store, { id, params }) {
        return API.updateRole(id, params)
            .then(res => res)
    },
    [T.DELETE_ROLE](store, id) {
        return API.deleteRole(id)
            .then(res => res)
    },
    [T.CREATE_BRANCH](store, payload) {
        return API.newWorkspace(payload).then(res => res)
    },
    [T.SELECT_DEFAULT_BRANCH]({ commit }, payload) {
        const { appId, workspaceId } = payload
        return API.selectDefaultBranch({
            appId, workspaceId,
        }).then(res => res).then(() => {
            commit(T.SET_CURRENT_WORKSPACE, payload)
        })
    },
    [T.GET_BRANCH_TAGS](store, payload) {
        return API.getBranchTags(payload).then(res => res)
    },
    [T.GET_SELECTED_BRANCH](store, payload) {
        return API.getBranchSelected(payload).then(res => res)
    },
}

export default actions
